import { render, staticRenderFns } from "./AgeRestrictedModal.vue?vue&type=template&id=df95732a&scoped=true"
import script from "./AgeRestrictedModal.vue?vue&type=script&lang=js"
export * from "./AgeRestrictedModal.vue?vue&type=script&lang=js"
import style0 from "./AgeRestrictedModal.vue?vue&type=style&index=0&id=df95732a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df95732a",
  null
  
)

export default component.exports